import { fetchApiFileBlob } from '@asd-stan/helpers/download-api-file';

export enum AttachmentKind {
	Ballot = 'ballot-attachments',
	Vote = 'vote-attachments',
}

export const fetchAttachmentBlob = (
	kind: AttachmentKind,
	id: number,
	signal?: AbortSignal
): Promise<Blob> => fetchApiFileBlob(`${kind}/${id}`, signal);
